<div class="modal-header">
  <h6 *ngIf="!isEdit" class="modal-title" i18n>Add Vendor</h6>
  <h6 *ngIf="isEdit" class="modal-title" i18n>Update Vendor</h6>
  <a (click)="close()" class="cstm-close">
    <span class="far fa-times"></span>
  </a>
</div>
<div class="modal-body bg-none px-0 py-3 m-0">
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="px-3">
      <div class="text-light text-uppercase mb-2" i18n>Vendor Details</div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input type="text" required matInput formControlName="name" i18n-placeholder placeholder="Name" />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
              Name is required
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="type" i18n-placeholder placeholder="Type" required>
              <mat-option *ngFor="let type of types" [value]="type">{{ type | titleCase }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')" i18n>
              Type is required
            </mat-error>
          </mat-form-field2>
        </div>

        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="email"
              formControlName="email"
              matInput
              required
              i18n-placeholder
              placeholder="Email"
              autocomplete="off"
            />
            <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')" i18n>
              Email is required
            </mat-error>
            <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('email')" i18n>
              Email must have valid format
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
    </div>
    <hr class="m-0" />
    <div class="px-3 pt-3">
      <div class="text-light text-uppercase mb-2" i18n>Vendor Location</div>
      <app-address-form [form]="addressForm"></app-address-form>
    </div>
    <hr class="m-0" />
    <div class="px-3 pt-3">
      <div class="row">
        <div class="col-md-12">
          <div class="text-light text-uppercase mb-2" i18n>Vendor Contact Details</div>
        </div>
        <div class="col-md-6">
          <app-phone-number-input [ctrl]="form.get('phone')" i18n-placeholder placeholder="Phone" [showPrefix]="true">
          </app-phone-number-input>
        </div>
        <div class="col-md-6">
          <div class="position-relative">
            <a
              href="javascript:;"
              (click)="onSendWhatsappMessage()"
              *ngIf="isEdit && !!form.get('whatsapp_number').value"
              class="position-absolute"
              style="right: 0; z-index: 1"
              i18n
              >Send Message</a
            >
            <app-phone-number-input
              [ctrl]="form.get('whatsapp_number')"
              prefixIcon="fab fa-whatsapp text-lg text-whatsapp"
              [showPrefix]="true"
              i18n-hint
              hint="WhatsApp message is free!"
              i18n-placeholder
              placeholder="WhatsApp Number"
            ></app-phone-number-input>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer border-top">
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>

  <button (click)="onSave(form)" type="button" [disabled]="1 | isReadonlyRole" class="btn btn-secondary-info">
    <span class="cs-icon cs-icon-save"></span> <ng-container i18n>Save</ng-container>
  </button>
</div>
